// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2388":"css/admin-app.7044","3183":"css/app.7044"}[chunkId] + ".css";
};